import { delayp0o4nsccwai as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { NativeContainerElementWithSecondaryActionpxt1q8w6be21 as NativeContainerElementWithSecondaryAction } from '../InteractiveElement.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { buttonDriverActionsadt7l0sftmbu as buttonDriverActions } from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Button$lambda$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(500n, $completion);
    var tmp0_safe_receiver = this$0.secondaryAction_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this$0.longPressDetect_1 = null;
      if (this$0.get_enabled_pcr8o8_k$()) {
        tmp0_safe_receiver.startAction_u0zgbm_k$($this$launch);
      }
    }
    return Unit_instance;
  }), 1);
}
var ButtonClass;
function Button() {
  if (ButtonClass === VOID) {
    class $ extends NativeContainerElementWithSecondaryAction() {
      constructor(context) {
        super(context);
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this.native_1.tag_1 = 'button';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        this.downPress_1 = new (Pair())(0.0, 0.0);
        this.longPressDetect_1 = null;
        var beginLongPressCountdown = (e) => {
          var me = e instanceof MouseEvent ? e : null;
          var tmp = this;
          var tmp1_elvis_lhs = me == null ? null : me.pageX;
          var tmp_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
          var tmp3_elvis_lhs = me == null ? null : me.pageY;
          tmp.downPress_1 = new (Pair())(tmp_0, tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
          var tmp_1 = this;
          var tmp4_elvis_lhs = this.longPressDetect_1;
          var tmp_2;
          if (tmp4_elvis_lhs == null) {
            tmp_2 = launch(this, VOID, VOID, Button$lambda$slambda(this));
          } else {
            tmp_2 = tmp4_elvis_lhs;
          }
          tmp_1.longPressDetect_1 = tmp_2;
          return Unit_instance;
        };
        var cancelOrClick = (e) => {
          var me = e instanceof MouseEvent ? e : null;
          var tmp0_safe_receiver = this.longPressDetect_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          var tmp;
          if (!(this.longPressDetect_1 == null)) {
            this.longPressDetect_1 = null;
            var tmp_0;
            if (!(me == null)) {
              var dx = me.pageX - this.downPress_1.first_1;
              var dy = me.pageY - this.downPress_1.second_1;
              // Inline function 'kotlin.math.sqrt' call
              var x = dx * dx + dy * dy;
              var dist = Math.sqrt(x);
              var tmp_1;
              if (dist <= 5) {
                var tmp1_safe_receiver = this.action_1;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  tmp1_safe_receiver.startAction_u0zgbm_k$(this);
                }
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
        var cancel = (event) => {
          var tmp0_safe_receiver = this.longPressDetect_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          this.longPressDetect_1 = null;
          return Unit_instance;
        };
        var keypress = (event) => {
          if (!(event instanceof KeyboardEvent))
            THROW_CCE();
          var tmp;
          if (event.code === KeyCodes_instance.get_space_iyncv1_k$() || event.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
            var tmp_0;
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
              var tmp0_elvis_lhs = this.secondaryAction_1;
              tmp_0 = tmp0_elvis_lhs == null ? this.action_1 : tmp0_elvis_lhs;
            } else {
              tmp_0 = this.action_1;
            }
            var a = tmp_0;
            if (a == null)
              null;
            else {
              a.startAction_u0zgbm_k$(this);
            }
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        var tmp0 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name = 'mousedown';
        var listener = beginLongPressCountdown;
        var tmp0_safe_receiver = tmp0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener(name, (it) => {
            listener(it);
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = tmp0.eventsBack_1['on' + name];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + name;
          tmp0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener(it);
            return Unit_instance;
          };
        }
        var tmp0_0 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_0 = 'touchstart';
        var listener_0 = beginLongPressCountdown;
        var tmp0_safe_receiver_0 = tmp0_0.element_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener(name_0, (it) => {
            listener_0(it);
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = tmp0_0.eventsBack_1['on' + name_0];
          var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + name_0;
          tmp0_0.eventsBack_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_0(it);
            return Unit_instance;
          };
        }
        var tmp0_1 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_1 = 'keypress';
        var listener_1 = keypress;
        var tmp0_safe_receiver_1 = tmp0_1.element_1;
        var tmp_5;
        if (tmp0_safe_receiver_1 == null) {
          tmp_5 = null;
        } else {
          tmp0_safe_receiver_1.addEventListener(name_1, (it) => {
            listener_1(it);
            return Unit_instance;
          });
          tmp_5 = Unit_instance;
        }
        if (tmp_5 == null) {
          // Inline function 'kotlin.run' call
          var tmp_6 = tmp0_1.eventsBack_1['on' + name_1];
          var old_1 = (!(tmp_6 == null) ? typeof tmp_6 === 'function' : false) ? tmp_6 : null;
          var tmp_7 = 'on' + name_1;
          tmp0_1.eventsBack_1[tmp_7] = (it) => {
            var tmp0_safe_receiver = old_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_1(it);
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var listener_2 = cancelOrClick;
        var tmp0_safe_receiver_2 = this_0.element_1;
        var tmp_8;
        if (tmp0_safe_receiver_2 == null) {
          tmp_8 = null;
        } else {
          tmp0_safe_receiver_2.addEventListener('mouseup', (it) => {
            listener_2(it);
            return Unit_instance;
          });
          tmp_8 = Unit_instance;
        }
        if (tmp_8 == null) {
          // Inline function 'kotlin.run' call
          var tmp_9 = this_0.eventsBack_1['on' + 'mouseup'];
          var old_2 = (!(tmp_9 == null) ? typeof tmp_9 === 'function' : false) ? tmp_9 : null;
          var tmp_10 = 'on' + 'mouseup';
          this_0.eventsBack_1[tmp_10] = (it) => {
            var tmp0_safe_receiver = old_2;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_2(it);
            return Unit_instance;
          };
        }
        var tmp0_2 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_2 = 'mouseleave';
        var listener_3 = cancel;
        var tmp0_safe_receiver_3 = tmp0_2.element_1;
        var tmp_11;
        if (tmp0_safe_receiver_3 == null) {
          tmp_11 = null;
        } else {
          tmp0_safe_receiver_3.addEventListener(name_2, (it) => {
            listener_3(it);
            return Unit_instance;
          });
          tmp_11 = Unit_instance;
        }
        if (tmp_11 == null) {
          // Inline function 'kotlin.run' call
          var tmp_12 = tmp0_2.eventsBack_1['on' + name_2];
          var old_3 = (!(tmp_12 == null) ? typeof tmp_12 === 'function' : false) ? tmp_12 : null;
          var tmp_13 = 'on' + name_2;
          tmp0_2.eventsBack_1[tmp_13] = (it) => {
            var tmp0_safe_receiver = old_3;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_3(it);
            return Unit_instance;
          };
        }
        var tmp0_3 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_3 = 'touchend';
        var listener_4 = cancelOrClick;
        var tmp0_safe_receiver_4 = tmp0_3.element_1;
        var tmp_14;
        if (tmp0_safe_receiver_4 == null) {
          tmp_14 = null;
        } else {
          tmp0_safe_receiver_4.addEventListener(name_3, (it) => {
            listener_4(it);
            return Unit_instance;
          });
          tmp_14 = Unit_instance;
        }
        if (tmp_14 == null) {
          // Inline function 'kotlin.run' call
          var tmp_15 = tmp0_3.eventsBack_1['on' + name_3];
          var old_4 = (!(tmp_15 == null) ? typeof tmp_15 === 'function' : false) ? tmp_15 : null;
          var tmp_16 = 'on' + name_3;
          tmp0_3.eventsBack_1[tmp_16] = (it) => {
            var tmp0_safe_receiver = old_4;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_4(it);
            return Unit_instance;
          };
        }
        var tmp0_4 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_4 = 'touchcancel';
        var listener_5 = cancel;
        var tmp0_safe_receiver_5 = tmp0_4.element_1;
        var tmp_17;
        if (tmp0_safe_receiver_5 == null) {
          tmp_17 = null;
        } else {
          tmp0_safe_receiver_5.addEventListener(name_4, (it) => {
            listener_5(it);
            return Unit_instance;
          });
          tmp_17 = Unit_instance;
        }
        if (tmp_17 == null) {
          // Inline function 'kotlin.run' call
          var tmp_18 = tmp0_4.eventsBack_1['on' + name_4];
          var old_5 = (!(tmp_18 == null) ? typeof tmp_18 === 'function' : false) ? tmp_18 : null;
          var tmp_19 = 'on' + name_4;
          tmp0_4.eventsBack_1[tmp_19] = (it) => {
            var tmp0_safe_receiver = old_5;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_5(it);
            return Unit_instance;
          };
        }
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), buttonDriverActions(this));
      }
      nativeSetAction_dc0jqw_k$(action) {
        var tmp = this.native_1;
        var tmp0_elvis_lhs = this.get_accessibleLabel_uztlo5_k$();
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp_0 = action == null ? null : action.get_title_iz32un_k$();
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.setAttribute_j9pxft_k$('aria-label', tmp_0);
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
    }
    initMetadataForClass($, 'Button');
    ButtonClass = $;
  }
  return ButtonClass;
}
//region block: exports
export {
  Button as Button263cw152yl80e,
};
//endregion

//# sourceMappingURL=Button.commonHtml.mjs.map
